module.exports = __webpack_public_path__ + "media/img/vca/nomf0-14e19d72a3f68b5080915acb87c04f15.png";